import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { modalWindows } from 'src/actions';
import { ADD_HACKATHON_URL } from 'src/constants/configuration';

// --- Modal Windows ---
import ModalWrapper from './ModalWrapper.js';
import AddHackathon from './AddHackathon';
import ShareNews from './ShareNews';
import AddReview from './AddReview';
import ResetPassword from './ResetPassword';
import Company from './About/Company';
import Hacker from './About/Hacker';
import Organizer from './About/Organizer';

class AddHackathonModal extends Component {
  constructor() {
    super();
    this.previousUrl = '/hackathons';
  }

  componentDidMount() {
    this.updateModal();
  }

  componentDidUpdate() {
    this.updateModal();
  }

  updateModal() {
    const pathName = this.props.location.pathname;
    const isModalOpened = this.isModalOpened();
    if (!isModalOpened) {
      if (pathName === ADD_HACKATHON_URL) {
        this.props.openAddHackModal();
      } else {
        this.previousUrl = pathName;
      }
    }
  }

  closeModal = (redirectUrl) => {
    if (this.props.isAddHackModalOpened) {
      this.props.history.push(this.previousUrl);
    }
    if (redirectUrl) {
      this.props.history.push(redirectUrl);
    }
    this.props.closeAllModals();
  }

  getModalChildren = () => {
    if (this.props.isShareNewsOpened) {
      return (<ShareNews closeModal={this.closeModal} />);
    }
    if (this.props.isAddReviewOpened) {
      return (<AddReview closeModal={this.closeModal} />);
    }
    if (this.props.isResetPasswordOpened) {
      return (<ResetPassword closeModal={this.closeModal} resetToken={this.props.resetToken}/>);
    }
    if (this.props.isCompanyOpened) {
      return (<Company closeModal={this.closeModal} />);
    }
     if (this.props.isHackerOpened) {
      return (<Hacker closeModal={this.closeModal} />);
    }
     if (this.props.isOrganizerOpened) {
      return (<Organizer closeModal={this.closeModal} />);
    }
    return (<AddHackathon closeModal={this.closeModal} />);
  }

  isModalOpened = () => {
    return this.props.isAddHackModalOpened || this.props.isShareNewsOpened || this.props.isAddReviewOpened || this.props.isResetPasswordOpened || this.props.isCompanyOpened || this.props.isHackerOpened || this.props.isOrganizerOpened;
  }

  render() {
    return (
      <ModalWrapper
        isOpened={this.isModalOpened()}
        onClose={this.closeModal}
      >
        { this.getModalChildren() }
      </ModalWrapper>
    );
  }
}

AddHackathonModal.propTypes = {
  isAddHackModalOpened: PropTypes.bool.isRequired,
  isShareNewsOpened: PropTypes.bool.isRequired,
  isAddReviewOpened: PropTypes.bool.isRequired,
  isResetPasswordOpened: PropTypes.bool.isRequired,
  isCompanyOpened: PropTypes.bool.isRequired,
  isHackerOpened: PropTypes.bool.isRequired,
  isOrganizerOpened: PropTypes.bool.isRequired,
  resetToken: PropTypes.string,
  location: PropTypes.object.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
  openAddHackModal: PropTypes.func.isRequired,
  openPasswordReset: PropTypes.func.isRequired,
  closeAllModals: PropTypes.func.isRequired,
}

function mapStateToProps(state) {
  return {
    isAddHackModalOpened: state.modalWindows.addHackathonOpened,
    isShareNewsOpened: state.modalWindows.shareNewsOpened,
    isAddReviewOpened: state.modalWindows.addReviewOpened,
    isResetPasswordOpened: state.modalWindows.resetPasswordOpened,
    isCompanyOpened: state.modalWindows.companyOpened,
    isHackerOpened: state.modalWindows.hackerOpened,
    isOrganizerOpened: state.modalWindows.organizerOpened,
    resetToken: state.modalWindows.resetToken,
  };
}

export default withRouter(
  connect(mapStateToProps, {
    openAddHackModal: modalWindows.openAddHackatonModal,
    openPasswordReset: modalWindows.openResetPwdModal,
    closeAllModals: modalWindows.closeAllModals,
  })(AddHackathonModal)
);



// WEBPACK FOOTER //
// ./src/components/Modal/index.js